export default __webpack_public_path__ + "static/media/Icon9.c22eb05d.svg";